import { useParams } from "react-router-dom";
import Form from "../../../Components/Form";
import Factor from "../../../Components/Factor";

import "./Operation.scss";

export default function Operation() {
  let id = useParams()["id"];
  let type = id === "2-m" ? "sell" : id === "1-m" && "buy";

  return (
    <div className="operation-page">
      {type === "sell" || type === "buy" ? (
        <Factor type={type} />
      ) : (
        <Form id={id} />
      )}
    </div>
  );
}
